import { Component, Input } from '@angular/core';

export interface OrderPhotoCountLinkCellValue {
    orderId: number;
    photoCount: number;
}

@Component({
    selector: 'bcm-order-photo-count-link',
    templateUrl: './order-photo-count-link.component.html',
    styleUrls: ['./order-photo-count-link.component.scss'],
    standalone: false,
})
export class OrderPhotoCountLinkComponent {
    @Input()
    orderId: number | null = null;

    @Input()
    photoCount = 0;

    @Input()
    set cellValue(value: OrderPhotoCountLinkCellValue | null | undefined) {
        this.orderId = value?.orderId ?? null;
        this.photoCount = Number(value?.photoCount ?? 0);
    }

    onClick(event: MouseEvent): void {
        event.stopPropagation();
    }
}
